import React, { useState, useEffect } from "react";
import "../css/ModalAlert.css";
import * as hasura from "../service/hasura";

import delete_image from "../image/delete.png";
import success_image from "../image/success.png";

export default function ModalAlert(props) {
  const [showDetail, setShowDetail] = useState("");
  const [typeAlert, setTypeAlert] = useState("error");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [currentSubscriptionId, setCurrentSubscriptionId] = useState(props?.subscriptionId);

  useEffect(() => {
    /*if (props.typeAlert === "success_add_fund") {
      setShowDetail("เพิ่มกองทุนเสร็จสิ้น");
      setTypeAlert("success");
    } else if (props.typeAlert === "alert_delete") {
      setShowDetail("แก้ไขกองทุนเสร็จสิ้น");
      setTypeAlert("success");
    }*/
  }, [props.typeAlert]);

  const handleCloseAlert = () => {
    if (props.typeAlert === "alert_delete") {
      props.statusShow(false);
      if (typeof props.onDeleteSuccess === "function") {
        props.onDeleteSuccess();
      } else {
        window.location.reload(false);
      }
    } else {
      props.statusShow(false);
    }
  };

  const handleDisableBtn = () => {
    if (!isButtonDisabled) {
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    }
  };

  const handleDelete = async () => {
    handleDisableBtn();

    try {
      let res = await hasura.deleteSubscription(currentSubscriptionId);
      //console.log(res);
      setShowDetail("เสร็จสิ้น");
      setTypeAlert("success");
      setCurrentSubscriptionId();
    } catch (error) {
      //console.error(error);
    }
    /*
    hasura.deleteSubscription(currentSubscriptionId).then((res) => {
      console.log(res);
      setShowDetail("เสร็จสิ้น");
      setTypeAlert("success");
      setCurrentSubscriptionId();
    });
    */
  };

  return (
    <>
      {currentSubscriptionId ? (
        <>
            <div className="modal-confirm-container">
              <div className="modal-confirm-content">
                <img
                  src={delete_image}
                />
                <span className="haeder-text">ยืนยันการลบพื้นที่</span>
                <span style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                  <span className="content-text">คุณกำลัง</span>
                  <span className="content-text-info">ลบสถานที่&nbsp;</span>
                  <span className="content-text-info-underline">{props.currentSubscriptionName}</span>
                </span>
                <span style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                  <span className="content-text">ยืนยันอีกครั้งเพื่อลบสถานที่นี้</span>
                </span>
                <div className="container-btn">
                  <div
                    className="btn-cancel"
                    onClick={() => {
                      props.statusShow(false);
                    }}
                  >
                    <span>ยกเลิก</span>
                  </div>
                  <div
                    className={"btn-ok"}
                    disabled={isButtonDisabled}
                    onClick={handleDelete}
                  >
                    <span>ลบ</span>
                  </div>
                </div>
              </div>
            </div>
          
        </>
      ) : (
        <div className="modal-alert-container">
          <div className='modal-alert-content'>
            <img
              src={success_image}
            />
            <span className="detail-txt">{showDetail}</span>
            <span className="detail-txt-2nd">ลบพื้นที่เรียบร้อยแล้ว</span>
            <div
              className='button success'
              onClick={handleCloseAlert}
            >
              <span>เสร็จสิ้น</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
